<template>
  <div>
    <!-- 顶部查询列表 -->
    <div class="main_container findneirong12" v-show="showbanner">
      <div class="fuji" @click="show3 = !show3">
        <p class="goodslist1">
          <span style="margin-left:21px;margin-top:5px">搜索/查询</span>
          <span class="goods_red"/>
        </p>
        <div style="position: absolute;right:-10px;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
        <div style="padding:0 12px" v-show="show3">
          <div class="find" v-show="showbanner">
            <el-form
              :inline="true"
              :model="formInline"
              style="display:flex;margin-top:10px;height:55px"
              class="demo-form-inline"
            >
              <el-form-item style="display:flex;width:100%;" label="品牌选择：" class="demo-item">
                <el-select v-model="brandId" style="width:100%" filterable class="demo-select" placeholder="请选择">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in pinpaiptions"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
             
                <el-form-item style="display:flex;width:100%;margin-left:30px" label="销售类型：" class="demo-item">
                  <el-select v-model="showtype" style="width:100%" class="demo-select" placeholder="请选择销售类型">
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in moretype"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
               <el-form-item style="display:flex;width:100%;margin-left:30px" label="商品类型：" class="demo-item">
                  <el-select style="width:100%"  v-model="CommodityId" class="demo-select" placeholder="请选择商品类型">
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in   Commoditytypes"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
            </el-form>
            <el-form
              :inline="true"
              style="display:flex;height:55px"
              :model="formInline"
              class="demo-form-inline2"
            >
              <el-form-item style="display:flex;width:100%" label="商品分类：" class="demo-item">
                <!-- <el-select v-model="shopTypeId" class="demo-select" placeholder="请选择一级分类" @change="cookienext()">
            <el-option 
               :label="item.Name"
                :value="item.Id"
                v-for="(item,index) in pinleiptions"
                :key="index">
            </el-option>
          </el-select>
          <el-select v-model="shopTypeId2" placeholder="请选择二级分类">
             <el-option 
               :label="item.Name"
                :value="item.Id"
                v-for="(item,index) in pinleinextptions"
                :key="index">
            </el-option>
                </el-select>-->
                <el-cascader
                  style="width:100%;"
                  placeholder="请选择"
                  :options="options1"
                  filterable
                  change-on-select
                  @change="handleChange1"
                ></el-cascader>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;margin-left:30px" label="所属城市：">
                <!-- <el-select v-model="provinceId" class="demo-select" placeholder="请选择省" @change="getCity()">
             <el-option   
                :label="item.Name"
                :value="item.Id"
                v-for="(item,index) in tbdprovince"
                :key="index">
                </el-option>
           
          </el-select>
          <el-select v-model="cityId" class="demo-select" placeholder="请选择市">
             <el-option   
                :label="item.Name"
                :value="item.Id"
                v-for="(item,index) in tbdcity"
                :key="index">
                </el-option>
                </el-select>-->
                <el-cascader style="width:100%"
                  placeholder="请选择城市"
                  :options="options"
                  filterable
                  change-on-select
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;margin-left:30px" label="商品名称：">
                <el-input style="width:100%" class="findgoods" v-model="name" placeholder="请输入查询商品名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
            <div style="float:right;margin-bottom:10px;margin-top:-20px;margin-right:10px" v-show="showbanner">
      <el-button @click="Search ()" class="Establish">查询</el-button>
      <el-button @click="reset ()" class="Reset">重置</el-button>
      </div>
        </div>
      </el-collapse-transition>

    
    </div>
    <!-- 表格   -->
    <div class="banner_table">
      <div v-show="showbanner">
        <p class="tittle">
          <span
            @click="left_span()"
            style="margin-left:5px;display:inline-block;height:30px;cursor:pointer "
          >已配置</span>
          <span
            @click="right_span()"
            style="margin-left:25px;display:inline-block;height:30px;cursor:pointer "
          >未配置</span>
          <span class="wei" v-show="span1_show"></span>
          <span class="yi" v-show="span2_show"></span>
        </p>
        <div class="noshop" v-show="shopshow">请搜索添加商品</div>
        <!-- 查询表格 -->
        <template>
          <div v-show="tableshow">
            <!-- 已配置 -->
            <el-table
              :data="tableData"
              align="center"
              border
             
              style="width: 98%;height:auto"
              v-show="Configured"
            >
              <el-table-column prop="date" type="index" align="center" label="ID" width="100"></el-table-column>
              <el-table-column prop="name" align="center" label="主图/商品名称" width="300">
                <template scope="scope">
                  <img
                    style="width:50px;height:33px;float:left;margin-left:10px;"
                    :data-img="scope.row.FImgs"
                    @click="$imgPreview"
                    :src="scope.row.FImgs"
                  />
                   <span
                      :title="scope.row.Title"
                    style="display:inline-block;float:left;margin:10px 0 0 5px;width:200px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.Title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="GoodModelCode" align="center" label="商品编码" width="150">
                  <template scope="scope">
                    <span
                      :title="scope.row.GoodModelCode"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodModelCode}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="amount2" align="center" label="所属城市">
                  <template scope="scope">
                    <span
                      :title="scope.row.ProvinceName+'-'+scope.row.CityName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.ProvinceName}}-{{scope.row.CityName}}</span>
                  </template>
               
              </el-table-column>
              <el-table-column prop="TzrPrice" width="130px" align="center" label="销售价格（元）">
                <template scope="scope">
                   <span
                      :title="'￥'+scope.row.TzrPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.TzrPrice}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="BrandName" align="center" label="品牌名称">
                 <template scope="scope">
                    <span
                      :title="scope.row.BrandName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop align="center" label="商品分类">
              
                 <template scope="scope">
                    <span
                      :title="scope.row.GoodsTypeName+'-'+scope.row.GoodsBrandTypeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodsTypeName}}-{{scope.row.GoodsBrandTypeName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="GoodActiveName" align="center" label="销售类型">
                <template scope="scope">
                    <span
                      :title="scope.row.GoodActiveName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodActiveName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="BargainGoodsTypeName" align="center" label="商品类型">
                <template scope="scope">
                    <span
                      :title="scope.row.BargainGoodsTypeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BargainGoodsTypeName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="BargainPrice" align="center" label="砍价总金额">
                 <template scope="scope">
                    <span
                      :title="scope.row.BargainPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BargainPrice}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop align="center" label="砍价总人数">
                <template scope="scope">
                    <span
                      :title="scope.row.center"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.center}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="STime" align="center" label="生效日期">
                <template scope="scope">
                    <span
                      :title="scope.row.STime"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.STime}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="ETime" align="center" label="失效日期">
                 <template scope="scope">
                    <span
                      :title="scope.row.ETime"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.ETime}}</span>
                  </template>
              </el-table-column>
              <el-table-column width="180" fixed="right" prop align="center" label="操作">
                <template scope="scope">
                  
                  <!-- <a
                    @click="UpperShelf(scope)"
                    v-if="scope.row.State == 1"
                    href="javascript:;"
                    v-show="shangjia"
                    class="ahref"
                  >上架</a> -->
                    <span  v-if="scope.row.State == 1"   v-show="shangjia" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="UpperShelf(scope)" >
                        <i class="el-icon-upload2"></i>
                        上架
                  </span>
                  <!-- <a
                    href="javascript:;"
                    @click="updown(scope)"
                    v-if="scope.row.State == 2"
                    class="ahref"
                  >强制下架</a> -->
                      <span  v-if="scope.row.State == 2"   style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="updown(scope)" >
                        <i class="el-icon-download"></i>
                        强制下架
                  </span>
                  <!-- <a
                    href="javascript:;"
                    @click="changeInfo(scope)"
                    v-if="scope.row.State == 1"
                    class="ahref"
                  >修改</a> -->
                   <span  v-if="scope.row.State == 1" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="changeInfo(scope)" >
                        <i class="el-icon-edit-outline"></i>
                        修改
                  </span>
                  <!-- <a href="javascript:;" v-show="shuxing" @click="attribute(scope)" class="ahref">属性</a> -->
                   <span v-show="shuxing" style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="attribute(scope)" >
                        <i class="el-icon-tickets"></i>
                        属性
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 未配置 -->
            <el-table
              :data="tableData"
              align="center"
              border
             
              style="width: 98%;height:auto"
              v-show="notconfigured"
            >
              <el-table-column prop="date" type="index" align="center" label="ID" width="100"></el-table-column>
              <el-table-column prop="name" align="center" label="主图/商品名称" width="300">
                <template scope="scope">
                  <img
                    style="width:50px;height:33px;float:left;margin-left:10px;"
                    :src="scope.row.FImgs"
                  />
                  <span
                      :title="scope.row.Title"
                    style="display:inline-block;float:left;margin:10px 0 0 5px;width:200px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.Title}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="GoodModelCode" align="center" label="商品编码" width="150">
                  <template scope="scope">
                    <span
                      :title="scope.row.GoodModelCode"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodModelCode}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="amount2" align="center" label="所属城市">
                  <template scope="scope">
                    <span
                      :title="scope.row.ProvinceName+'-'+scope.row.CityName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.ProvinceName}}-{{scope.row.CityName}}</span>
                  </template>
               
              </el-table-column>
              <el-table-column prop="TzrPrice" width="130px" align="center" label="销售价格（元）">
                <template scope="scope">
                   <span
                      :title="'￥'+scope.row.TzrPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.TzrPrice}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="BrandName" align="center" label="品牌名称">
                 <template scope="scope">
                    <span
                      :title="scope.row.BrandName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop align="center" label="商品分类">
              
                 <template scope="scope">
                    <span
                      :title="scope.row.GoodsTypeName+'-'+scope.row.GoodsBrandTypeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodsTypeName}}-{{scope.row.GoodsBrandTypeName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="GoodActiveName" align="center" label="销售类型">
                <template scope="scope">
                    <span
                      :title="scope.row.GoodActiveName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodActiveName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="BargainGoodsTypeName" align="center" label="商品类型">
                <template scope="scope">
                    <span
                      :title="scope.row.BargainGoodsTypeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BargainGoodsTypeName}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="BargainPrice" align="center" label="砍价总金额">
                 <template scope="scope">
                    <span
                      :title="scope.row.BargainPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BargainPrice}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop align="center" label="砍价总人数">
                <template scope="scope">
                    <span
                      :title="scope.row.center"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.center}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="STime" align="center" label="生效日期">
                <template scope="scope">
                    <span
                      :title="scope.row.STime"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.STime}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="ETime" align="center" label="失效日期">
                 <template scope="scope">
                    <span
                      :title="scope.row.ETime"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.ETime}}</span>
                  </template>
              </el-table-column>
              <el-table-column fixed="right" prop align="center" label="操作">
                <template scope="scope">
                  <!-- <a
                    href="javascript:;"
                    v-show="shuxing"
                    @click="goconfigure(scope)"
                    class="ahref"
                  >配置</a> -->
                  <span style="color:#6786b4;margin-left:8px;cursor: pointer;" @click="goconfigure(scope)" >
                        <i class="el-icon-setting"></i>
                        配置
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="allchecked">
            <span style="margin-top:10px;margin-left:20px;" @click="allsure()">
              <el-checkbox v-model="checked">
                全选 (
                <span>4</span> / 5 )
              </el-checkbox>
            </span>
            <el-button class="addgoods">添加</el-button>
            </div>-->
          </div>
        </template>
        <div style="float:right;margin-top:10px;margin-bottom:10px;margin-right:30px">
          <el-pagination
            layout="prev, pager, next"
            :current-page="pageIndex"
            @current-change="handleCurrentChange"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <!-- 配置页面 -->
      <div v-show="goconfigureshow">
        <p class="tittle">
          <strong style="margin-left:10px;display:inline-block;height:30px;">配置</strong>
          <span class="wei"></span>
        </p>
        <!-- 商品详情 -->
        <p style="margin-top:30px;">
          <span class="red_info"></span>
          <strong style="margin-left:5px;margin-top:-1px;">商品信息</strong>
        </p>
        <div class="goodsinfo">
          <p class="oneinfo">
            <span class="alignment">商品主图：</span>
            <img style="width:120px;height:120px;margin-top:80px;" :src="shopsrc" />
          </p>
          <p class="oneinfo">
            <span class="alignment">商品名称：</span>
            <span>{{shopname}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">商品编码：</span>
            <span>{{shopnumber}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">品牌名称：</span>
            <span>{{shopBbname}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">商品分类：</span>
            <span>{{shopType}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">所属城市：</span>
            <span>{{shopcity}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">销售类型：</span>
            <span>{{shopactive}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">商品类型：</span>
            <span>{{shoplexing}}</span>
          </p>
          <p class="oneinfo">
            <span class="alignment">销售价格(元)：</span>
            <span>{{shopprice}}</span>
          </p>
        </div>
        <!-- 砍价配置 -->
        <p style="margin-top:50px;">
          <span class="red_info"></span>
          <strong style="margin-left:5px;margin-top:-1px;">砍价配置</strong>
        </p>
        <div class="klanjia">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            style="margin-left:175px;margin-bottom:80px;"
          >
            <el-form-item label="添加销售类型：" class="input" prop="name">
              <span>{{shopactive}}</span>
            </el-form-item>
            <el-form-item label="添加商品类型：" class="input" prop="name">
              <span>{{shoplexing}}</span>
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="砍价总额：" prop="name">
              <el-input
                style="width:220px"
                v-model="BargainPrice"
                onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"
                placeholder="仅支持正整数，且为10的倍数"
              ></el-input>
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="前台显示最低价：" prop="name">
              <el-input
                style="width:220px"
                v-model="ShowMinPrice"
                onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"
                placeholder="销售价格-砍价总额"
              ></el-input>
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="最多砍价人次：" prop="name">
              <el-input
                style="width:220px"
                v-model="MaxBargainNum"
                onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"
                placeholder="2<=输入内容<=8"
              ></el-input>* 10
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="参与砍价商品数量：" prop="name">
              <el-input
                style="width:220px"
                v-model="Stock"
                onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"
                placeholder="请输入参与砍价商品数量"
              ></el-input>
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="用户砍价有效时间" prop="name">
              <el-input style="width:220px" v-model="effectiveHour" placeholder="请输入有效时间"></el-input>
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="生效日期：" prop="name">
              <div class="block">
                <el-date-picker
                  v-model="STimepinzhi"
                  type="datetime"
                  placeholder="选择日期时间"
                  align="right"
                  :picker-options="pickerOptions1"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item style="width:600px;" class="input" label="失效日期：" prop="name">
              <div class="block">
                <el-date-picker
                  v-model="ETimepinzhi"
                  type="datetime"
                  placeholder="选择日期时间"
                  align="right"
                  :picker-options="pickerOptions2"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </div>
            </el-form-item>
            <!-- 按钮 -->
            <el-form-item style="margin-top:50px;margin-left:50px;">
              <el-button class="button" @click="resetForm()">重置</el-button>
              <el-button class="button" @click="submitForm()">确认</el-button>
              <el-button @click="quxiao()" class="button1">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 搜索/重置弹框 -->
    <div>
      <el-dialog
        style="margin-top:150px;"
        :title="Searchorreset ? '重置提示' : '错误提示' "
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span>{{Searchorreset?"是否重置所有的搜索项":"请选择搜索条件查询"}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="Whether()">{{Searchorreset?"是":"确定"}}</el-button>
          <el-button
            type="primary"
            v-show="Searchorreset"
            class="findEr1"
            @click="dialogVisible = false"
          >否</el-button>
        </span>
      </el-dialog>
      <!-- 属性弹框 -->
      <el-dialog style="margin-top:150px;" title="属性" :visible.sync="dialogVisiblecha" width="30%">
        <p>
          最后操作人：
          <span>{{OperatorName}}</span>
        </p>
        <p>
          创建日期：
          <span>{{CTime}}</span>
        </p>
        <p>
          修改日期：
          <span>{{LastUpdatorTime}}</span>
        </p>
        <p>
          上架日期：
          <span>{{STime}}</span>
        </p>
        <p>
          下架日期：
          <span>{{ETime}}</span>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="dialogVisiblecha = false">返回</el-button>
        </span>
      </el-dialog>
      <!-- 上架弹框 -->
      <el-dialog
        style="margin-top:150px;"
        title="开启提示"
        :visible.sync="dialogVisibleshangjia"
        width="30%"
      >
        <P>是否开启该商品砍价活动？</P>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="startActive()">是</el-button>
          <el-button type="primary" class="findEr" @click="dialogVisibleshangjia = false">否</el-button>
        </span>
      </el-dialog>
      <!-- 强制下架弹框 -->
      <el-dialog
        style="margin-top:150px;"
        title="强制下架提示"
        :visible.sync="dialogVisiblexiajia"
        width="30%"
      >
        <P>是否将该商品强制下线？</P>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="endActiveshow()">是</el-button>
          <el-button type="primary" class="findEr" @click="dialogVisiblexiajia = false">否</el-button>
        </span>
      </el-dialog>
      <!-- 下架原因弹框 -->
      <el-dialog
        style="margin-top:150px;"
        title="下架原因"
        :visible.sync="dialogVisibleyuanyin"
        width="30%"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="下架原因" class="whyclose" prop="whyend">
            <el-input v-model="ruleForm.whyend" placeholder="请输入下架原因"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="endActive('ruleForm')">是</el-button>
          <el-button type="primary" class="findEr" @click="endActiveover('ruleForm')">否</el-button>
        </span>
      </el-dialog>
      <!-- 取消弹框 -->
      <el-dialog
        style="margin-top:150px;"
        title="提示"
        :visible.sync="dialogVisiblequxiao"
        width="30%"
      >
        <P>是否取消编辑？ 若返回将不保存已配置内容</P>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="quxiaosure()">是</el-button>
          <el-button type="primary" class="findEr" @click="dialogVisiblequxiao = false">否</el-button>
        </span>
      </el-dialog>
      <!-- 重置弹框 -->
      <el-dialog
        style="margin-top:150px;"
        title="重置提示"
        :visible.sync="dialogVisiblechongzhi"
        width="30%"
      >
        <P>是否重置？</P>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="chongzhisure()">是</el-button>
          <el-button type="primary" class="findEr" @click="dialogVisiblechongzhi = false">否</el-button>
        </span>
      </el-dialog>
      <!-- 配置保存 -->
      <el-dialog style="margin-top:150px;" title="提示" :visible.sync="dialogVisiblesure" width="30%">
        <P>是否确认提交？</P>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="findEr" @click="peizhisure()">是</el-button>
          <el-button type="primary" class="findEr" @click="dialogVisiblesure = false">否</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
    </div>
  </div>
</template>
<script>
import { getkind, SettingList, UpperShelf, BargainGoodsById, SettingBargainGoods, LowerShelf } from "../../api/api";
export default {
  data() {
    return {
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      optionsindex1: 0,
      options1: [
        {
          value: 0,
          label: "全部"
        }
      ],
      show3: false,
      pickerOptions1: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      change: false,
      changeId: "",
      MakeorChange: 1,
      effectiveHour: "",
      ShowMinPrice: "",
      BargainPrice: "",
      MaxBargainNum: "",
      Stock: "",
      STimepinzhi: "",
      ETimepinzhi: "",
      shopsrc: "",
      shopname: "",
      shopnumber: "",
      shopBbname: "",
      shopType: "",
      shopcity: "",
      shopactive: "",
      shoplexing: "",
      shopprice: "",
      scopeId: "",
      endscopeId: "",
      total: 0,
      pageIndex: 1,
      isSetting: 1,
      xiajia: false,
      shangjia: true,
      xiugai: true,
      shuxing: true,
      name: "",
      CommodityId: 0,
      shopTypeId2: 0,
      brandId: 0,
      showtype: 0,
      shopTypeId: 0,
      provinceId: 0,
      cityId: 0,
      pinleinextptions: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      pinleiptions: [],
      pinpaiptions: [],
      moretype: [],
      tbdprovince: [],
      tbdcity: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      Commoditytypes: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "单品"
        }
      ],
      Searchorreset: false,
      dialogVisibleshangjia: false,
      dialogVisiblexiajia: false,
      dialogVisibleyuanyin: false,
      dialogVisiblecha: false,
      dialogVisiblequxiao: false,
      dialogVisiblechongzhi: false,
      dialogVisiblesure: false,
      dialogVisible: false,
      showbanner: true,
      goconfigureshow: false,
      span1_show: true,
      span2_show: false,
      Configured: true,
      notconfigured: false,
      checked: false,
      tableData: [],
      OperatorName: "",
      CTime: "",
      LastUpdatorTime: "",
      STime: "",
      ETime: "",
      ruleForm: {
        whyend: ""
      },
      rules: {
        whyend: [
          { required: true, message: "请输入下架原因", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "输入内容在 1 到 100 个字符",
            trigger: "blur"
          }
        ]
        // region: [
        //   { required: true, message: "请输入奖券来源", trigger: "blur" },
        //   { min: 0, max: 50, message: "长度在 0 到 50 个字符", trigger: "blur" }
        // ],
      },
      shopshow: false,
      tableshow: true,
      formInline: {
        user: "",
        region: ""
      }
    };
  },
  methods: {
    handleChange1(val) {
      this.shopTypeId = val[0];
      if (val.length == 1) {
        for (var i = 0; i < this.options1.length; i++) {
          if (this.options1[i].value == val[0]) {
            this.optionsindex1 = i;
            this.getpinleinext();
            this.$forceUpdate();
          }
        }

        this.shopTypeId2 = 0;
      } else {
        this.shopTypeId = val[0];
        this.shopTypeId2 = val[1];
      }
    },
    handleChange(val) {
      this.provinceId = val[0];
      if (val.length == 1) {
        for (var i = 0; i < this.options.length; i++) {
          if (this.options[i].value == val[0]) {
            this.optionsindex = i;
            this.getcity();
            this.$forceUpdate();
          }
        }

        this.cityId = 0;
      } else {
        this.provinceId = val[0];
        this.cityId = val[1];
      }
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.findBargainingGoods();
    },
    //配置确认
    submitForm() {
      // this.dialogVisiblesure = true;
           this.$swal({
       type:'warning',
    text: '是否确认提交？',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
   if(res.value){
  this.peizhisure()
   }
    
  })
      // var obj = {
      //        ShowMinPrice:this.ShowMinPrice,
      //        BargainPrice:this.BargainPrice,
      //        MaxBargainNum:this.MaxBargainNum,
      //        Stock:this.Stock,
      //        STime:this.STimepinzhi,
      //        ETime:this.ETimepinzhi,
      //        Id:localStorage.BargainId,
      //        OperatorId:localStorage.Id
      // }
      // SettingBargainGoods(obj).then(data=>{
      //   if(data.ResultCode == 1){
      //      this.showbanner = true;
      //      this.goconfigureshow = false;
      //      this.findBargainingGoods()
      //   }
      // })
    },
    peizhisure() {
      if (this.BargainPrice < 100) {
        this.dialogVisiblesure = false;
        this.$swal({
          text:"请输入砍价总额大于100",
          tyoe:"warning"
        })
      } else if (this.ShowMinPrice == "") {
        this.dialogVisiblesure = false;
         this.$swal({
          text:"请输入前台显示最低价",
          tyoe:"warning"
        })
      } else if (this.MaxBargainNum < 2 || this.MaxBargainNum > 8) {
        this.dialogVisiblesure = false;
         this.$swal({
          text:"请输入最多砍价人次大于2且小于8",
          tyoe:"warning"
        })
      } else if (this.Stock == "") {
        this.dialogVisiblesure = false;
        this.$swal({
          text:"请输入参与砍价商品数量",
          tyoe:"warning"
        })
      } else if (this.effectiveHour == "") {
        this.dialogVisiblesure = false;
         this.$swal({
          text:"请输入砍价有效日期",
          tyoe:"warning"
        })
      } else if (this.STimepinzhi == "") {
        this.dialogVisiblesure = false;
         this.$swal({
          text:"请输入生效日期",
          tyoe:"warning"
        })
      } else if (this.ETimepinzhi == "") {
        this.dialogVisiblesure = false;
        this.$swal({
          text:"请输入失效日期",
          tyoe:"warning"
        })
      } else {
        this.dialogVisiblesure = false;
        var obj = {
          ShowMinPrice: this.ShowMinPrice,
          BargainPrice: this.BargainPrice,
          MaxBargainNum: this.MaxBargainNum,
          Stock: this.Stock,
          EffectiveHour: this.effectiveHour,
          STime: this.STimepinzhi,
          ETime: this.ETimepinzhi,
          Id: localStorage.BargainId,
          OperatorId: localStorage.Id
        };
        SettingBargainGoods(obj).then(data => {
          if (data.ResultCode == 1) {
            this.showbanner = true;
            this.goconfigureshow = false;
            this.findBargainingGoods();
          }
        });
      }
    },
    //属性
    attribute(scope) {
      var obj = {
        id: Number(scope.row.Id)
      };
      BargainGoodsById(obj).then(data => {
        if (data.ResultCode == 1) {
          this.OperatorName = data.ResultObj.LastUpdatorName;
          this.CTime = data.ResultObj.CTime;
          this.LastUpdatorTime = data.ResultObj.LastUpdatorTime;
          this.STime = data.ResultObj.STime;
          this.ETime = data.ResultObj.ETime;
          this.dialogVisiblecha = true;
        }
      });
    },

    //上架
    UpperShelf(scope) {
      // this.dialogVisibleshangjia = true;
      this.scopeId = scope.row.Id;
           this.$swal({
       type:'warning',
    text: '是否开启该商品砍价活动？',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
   if(res.value){
     this.startActive()
   }
    
  })
      // var obj = {res.value
      //   Id : Number(scope.row.Id),
      //   OperatorId:Number(localStorage.Id)
      // }
      // UpperShelf(obj).then(data=>{
      //   if(data.ResultCode == 1){
      //     this.findBargainingGoods()
      //   }
      // });
    },
    startActive() {
      var obj = {
        Id: Number(this.scopeId),
        OperatorId: Number(localStorage.Id)
      };
      UpperShelf(obj).then(data => {
        if (data.ResultCode == 1) {
          this.dialogVisibleshangjia = false;
          this.$swal({
            text:"上架成功",
            tyoe:"success"
          })
          this.findBargainingGoods();
        }
      });
    },
    //强制下架
    updown(scope) {
      this.endscopeId = scope.row.Id;
      // this.dialogVisiblexiajia = true;
      this.ruleForm.whyend = "";
           this.$swal({
       type:'warning',
    text: '是否将该商品强制下线？',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
 if(res.value){
   this.endActiveshow()
 }
  
  })
    },
    endActiveshow() {
      this.dialogVisibleyuanyin = true;
    },
    endActive(formName) {
      if (this.ruleForm.whyend == "") {
        this.$refs[formName].validate(valid => {
          if (valid) {
            alert("submit!");
          } else {
            return false;
          }
        });
      } else if (this.ruleForm.whyend.length > 100) {
        return false;
      } else {
        var obj = {
          Id: Number(this.endscopeId),
          Remark: this.ruleForm.whyend,
          OperatorId: Number(localStorage.Id)
        };
        LowerShelf(obj).then(data => {
          if (data.ResultCode == 1) {
            this.dialogVisiblexiajia = false;
            this.dialogVisibleyuanyin = false;
            this.$swal({
              text:"下架成功",
              tyoe:"success"
            })
            this.findBargainingGoods();
          }
        });
      }
    },
    endActiveover(formName) {
      this.dialogVisibleyuanyin = false;
      this.$refs[formName].resetFields();
    },
    //查看二级分类
    cookienext() {
      this.getpinleinext();
      this.shopTypeId2 = 0;
      if (this.shopTypeId == 0) {
        this.pinleinextptions = [
          {
            Id: 0,
            Name: "全部"
          }
        ];
      }
    },
    //市
    getCity() {
      this.getcity();
      this.cityId = 0;
    },
    onSubmit() {
      console.log("submit!");
    },
    // 全选
    allsure() {
      if (this.checked) {
        this.tableData6.filter((item, index) => {
          item.isChecked = false;
        });
      } else {
        this.tableData6.filter((item, index) => {
          item.isChecked = true;
        });
      }
    },
    sure(i) {
      console.log(i);
    },
    // 左侧已配置
    left_span() {
      this.span1_show = true;
      this.span2_show = false;
      this.Configured = true;
      this.notconfigured = false;
      this.isSetting = 1;
      this.pageIndex = 1;
      this.findBargainingGoods();
    },
    // 右侧未配置
    right_span() {
      this.span1_show = false;
      this.span2_show = true;
      this.Configured = false;
      this.notconfigured = true;
      this.isSetting = 2;
      this.pageIndex = 1;
      this.findBargainingGoods();
    },
    // 点击配置
    goconfigure(scope) {
      this.MakeorChange = 1;
      this.change = false;
      this.showbanner = false;
      this.goconfigureshow = true;
      this.shopsrc = scope.row.FImgs;
      this.shopname = scope.row.Title;
      this.shopnumber = scope.row.BargainGoodsNo;
      this.shopBbname = scope.row.BrandName;
      this.shopType = scope.row.GoodsBrandTypeName;
      this.shopcity = scope.row.ProvinceName + "-" + scope.row.CityName;
      this.shopactive = scope.row.GoodActiveName;
      this.shoplexing = scope.row.BargainGoodsTypeName;
      this.shopprice = scope.row.TzrPrice;
      localStorage.BargainId = scope.row.Id;
      this.ShowMinPrice = "";
      this.BargainPrice = "";
      this.MaxBargainNum = "";
      this.Stock = "";
      this.effectiveHour = "";
      this.STimepinzhi = "";
      this.ETimepinzhi = "";
    },
    //配置重置
    resetForm() {
      // this.dialogVisiblechongzhi = true;
           this.$swal({
       type:'warning',
    text: '是否重置？',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
 if(res.value){
   this.chongzhisure()
 }
    
  })
    },
    chongzhisure() {
      if (this.change) {
        this.dialogVisiblechongzhi = false;
        var obj = {
          id: this.changeId
        };
        BargainGoodsById(obj).then(data => {
          this.shopsrc = data.ResultObj.FImgs;
          this.shopname = data.ResultObj.Title;
          this.shopnumber = data.ResultObj.BargainGoodsNo;
          this.shopBbname = data.ResultObj.BrandName;
          this.shopType = data.ResultObj.GoodsBrandTypeName;
          this.shopcity =
            data.ResultObj.ProvinceName + "-" + data.ResultObj.CityName;
          this.shopactive = data.ResultObj.GoodActiveName;
          this.shoplexing = data.ResultObj.BargainGoodsTypeName;
          this.shopprice = data.ResultObj.TzrPrice;
          this.ShowMinPrice = data.ResultObj.ShowMinPrice;
          this.BargainPrice = data.ResultObj.BargainPrice;
          this.MaxBargainNum = data.ResultObj.MaxBargainNum;
          this.Stock = data.ResultObj.Stock;
          this.STimepinzhi = data.ResultObj.STime;
          this.ETimepinzhi = data.ResultObj.ETime;
          this.effectiveHour = data.ResultObj.EffectiveHour;
        });
      } else {
        this.dialogVisiblechongzhi = false;
        this.ShowMinPrice = "";
        this.BargainPrice = "";
        this.MaxBargainNum = "";
        this.effectiveHour = "";
        this.Stock = "";
        this.STimepinzhi = "";
        this.ETimepinzhi = "";
      }
    },
    //配置取消
    quxiao() {
      // this.dialogVisiblequxiao = true;
           this.$swal({
       type:'warning',
    text: '是否取消编辑？ 若返回将不保存已配置内容',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
 if(res.value){
   this.quxiaosure()
 }
    
  })
    },
    quxiaosure() {
      this.ShowMinPrice = "";
      this.BargainPrice = "";
      this.MaxBargainNum = "";
      this.Stock = "";
      this.STimepinzhi = "";
      this.ETimepinzhi = "";
      this.showbanner = true;
      this.goconfigureshow = false;
      this.dialogVisiblequxiao = false;
    },
    //修改
    changeInfo(scope) {
      this.change = true;
      this.changeId = scope.row.Id;
      this.MakeorChange = 2;
      this.showbanner = false;
      this.goconfigureshow = true;
      var obj = {
        id: scope.row.Id
      };
      this.showbanner = false;
      this.goconfigureshow = true;
      this.shopsrc = scope.row.FImgs;
      this.shopname = scope.row.Title;
      this.shopnumber = scope.row.BargainGoodsNo;
      this.shopBbname = scope.row.BrandName;
      this.shopType = scope.row.GoodsBrandTypeName;
      this.shopcity = scope.row.ProvinceName + "-" + scope.row.CityName;
      this.shopactive = scope.row.GoodActiveName;
      this.shoplexing = scope.row.BargainGoodsTypeName;
      this.shopprice = scope.row.TzrPrice;
      BargainGoodsById(obj).then(data => {
        this.ShowMinPrice = data.ResultObj.ShowMinPrice;
        this.BargainPrice = data.ResultObj.BargainPrice;
        this.MaxBargainNum = data.ResultObj.MaxBargainNum;
        this.Stock = data.ResultObj.Stock;
        this.STimepinzhi = data.ResultObj.STime;
        this.ETimepinzhi = data.ResultObj.ETime;
        this.effectiveHour = data.ResultObj.EffectiveHour;
      });
    },
    //点击查询、
    Search() {
      if (
        this.CommodityId == 0 &&
        this.shopTypeId2 == 0 &&
        this.brandId == 0 &&
        this.showtype == 0 &&
        this.shopTypeId == 0 &&
        this.provinceId == 0 &&
        this.cityId == 0 &&
        this.name == ""
      ) {
        this.Searchorreset = false;
        // this.dialogVisible = true;
        this.$swal({
          type:"warning",
          text:"请选择搜索条件查询"
        })
        this.tableData = [];
      } else {
        this.findBargainingGoods();
      }
    },
    //点击重置
    reset() {
      this.Searchorreset = true;
      //this.dialogVisible = true;
           this.$swal({
       type:'warning',
    text: '是否重置所有的搜索项?',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
  if(res.value){
    this.Whether()
  }
    
  })
    },
    //点击是
    Whether() {
      if (this.Searchorreset) {
        this.CommodityId = 0;
        this.shopTypeId2 = 0;
        this.brandId = 0;
        this.showtype = 0;
        this.shopTypeId = 0;
        this.provinceId = 0;
        this.cityId = 0;
        this.name = "";
        this.dialogVisible = false;
        this.tableData = [];
      } else {
        this.dialogVisible = false;
      }
    },
    //下拉品牌
    getpinpai() {
      let that = this;
      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "全部"
          };
          data.unshift(obj);
          that.pinpaiptions = data;
        });
    },
    //商品分类
    getpinlei() {
      let that = this;
      var loginParams = {
        tableName: "tBDGoodsType",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          var obj = {};
          data.ResultObj.map(item => {
            obj = item;
            obj["value"] = item["Id"];
            obj["label"] = item["Name"];
            obj["children"] = [];
            delete obj["keyName"];
            delete obj["keyName"];
            this.options1.push(obj);
          });
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "全部"
          };
          data.unshift(obj);
          that.pinleiptions = data;
        });
    },
    getpinleinext() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsbrandtype",
        keyWord: "",
        parentId: this.shopTypeId
      };
      getkind(loginParams).then(data => {
        that.pinleinextptions = [];
        var obj1 = {
          value: 0,
          label: "全部"
        };
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          this.pinleinextptions.push(obj);
        });
        this.pinleinextptions.unshift(obj1);
        that.options1[that.optionsindex1].children = that.pinleinextptions;
        this.$forceUpdate();
      });
    },
    //销售类型
    gettype() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsactive",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.moretype = data;
      });
    },
    // 查找省
    getprovince() {
      let that = this;
      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          obj["children"] = [];
          this.options.push(obj);
        });
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.tbdprovince = data;
      });
    },
    // 查找市
    getcity() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.provinceId
      };
      getkind(loginParams).then(data => {
        that.tbdcity = [];
        var obj1 = {
          value: 0,
          label: "全部"
        };
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          this.tbdcity.push(obj);
        });
        this.tbdcity.unshift(obj1);
        that.options[that.optionsindex].children = that.tbdcity;
        this.$forceUpdate();
      });
    },
    //查询砍价商品配置列表
    findBargainingGoods() {
      var loginParams = {
        brandId: this.brandId,
        isSetting: this.isSetting,
        goodsType: this.shopTypeId,
        goodsTypeTwo: this.shopTypeId2,
        goodsActiveId: this.showtype,
        bargainType: this.CommodityId,
        province: this.provinceId,
        city: this.cityId,
        key: this.name,
        pageIndex: this.pageIndex,
        pageSize: 10,
        type: 0,
        userId: localStorage.Id
      };
      SettingList(loginParams).then(data => {
        this.tableData = data.ResultObj;
        this.total = data.RowsCount;
      });
    }
  },
  mounted() {
    //商品分类
    this.getpinlei();
    //下拉品牌
    this.getpinpai();
    this.gettype();
    //省
    this.getprovince();
  }
};
</script>
<style scoped>
.normal_width {
  width: 190px;
}
.nowfind {
  width: 260px;
  height: 141px;
  float: left;
}
.demo-form-inline {
  width: 100%;
  margin-top: 20px;
  height: 50px
}
.demo-form-inline2 {
  width: 100%;
}
.demo-select {
  width: 180px;
}
.findgoods {
  width: 300px;
}
.Establish {
  background: #F56C6C;
  color: #fff;
  margin-top: 20px;
}
.Reset {
  margin-top: 20px;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.banner_table {
  padding: 0 20px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 00);
  margin-top: 20px;
  top: 150px;
  min-height: 540px;
  width: 100%;
  float: left;
  /* overflow: hidden;
   */
}
.noshop {
  width: 100%;
  height: 400px;
  text-align: center;
  line-height: 400px;
  font-size: 25px;
  color: #999;
}
.allchecked {
  padding-top: 15px;
  width: 100%;
  height: 35px;
  background: rgba(187, 187, 187, 0.47);
}
.addgoods {
  color: #fff;
  background: #F56C6C;
  float: right;
  height: 30px;
  line-height: 8px;
  margin-right: 2%;
  margin-top: -5px;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}
.tittle {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #eee;
}
.wei {
  display: block;
  position: relative;
  width: 50px;
  height: 1px;
  background: #F56C6C;
  top: 10px;
  left: 2px;
}
.yi {
  display: block;
  position: relative;
  width: 50px;
  height: 1px;
  background: #F56C6C;
  top: 9px;
  left: 73px;
}
.red_info {
  display: inline-block;
  width: 2px;
  background: #F56C6C;
  height: 12px;
  margin-top: 5px;
}
.alignment {
  color: #888;
  display: inline-block;
  width: 150px;
  text-align: right;
}
.goodsinfo {
  margin-left: 10%;
  margin-top: -40px;
}
.oneinfo {
  margin-top: 30px;
}
.input {
  margin-bottom: 22px;
}
.button {
  background: #F56C6C;
  color: #fff;
}
.button1 {
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.findEr {
  border: 1px solid #F56C6C;
  background: #F56C6C;
  color: #fff;
}
.findEr1 {
  border: 1px solid #F56C6C;
  background: #fff;
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// Configuration.vue?4f6b2629